//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import ComponentsUtils from "../../mixins/components-utils";
import Events from "../../mixins/events";
import QFabricModal from "../../../q-fabric-modal.vue";
import QfMScriptEditor from "../script-editor/qf-m-script-editor.vue";
import UploadAbiFile from "./upload-abi-file.vue";

export default {
    name: "QfMBlockchainMapping",
    components: { QfMScriptEditor, QFabricModal, UploadAbiFile, AQCard },
    mixins: [ComponentsUtils, Events],
    props: {
        mapping: { type: Object, default: () => {} }
    },
    data() {
        return {
            thumbStyle: {
                right: "-7px", borderRadius: "2px", width: "4px", opacity: 0.4
            },
            localShow: true,
            selectedMethod: null,
            requestMapping: {},
            responseMapping: {},
            showModal: false,
            localValue: null,
            currentEdit: null,
            scriptRequest: { active: false, content: null },
            scriptResponse: { active: false, content: null },
            mappingList: [],
            requestMappingList: [],
            responseMappingList: [],
            address: null,
            noAddress: false,
            bcAddress: null,
            noBcAddress: false,
            chainId: null,
            methods: null,
            methodsData: null,
            dataAbi: null,
            fileName: null,
            methodType: null,
            abiToSend: null,
            contractExist: false,
            dataReturn: [],
            headerActions: [
                { label: this.$t("blockchainBuilder.delete"), name: "delete", disabled: false }
            ]
        };
    },
    computed: {
        ...mapState("components", ["properties", "components"]),
        ...mapGetters("components", ["parsedAPI"]),
        actions() {
            return [{ label: this.$t("blockchainBuilder.save"), name: "save", disable: !this.selectionDone }];
        },
        selectionDone() {
            return this.selectedMethod;
        },
        requestTitle() {
            let title;
            if (this.selectionDone) {
                const prmLength = this.requestList.length; let
                    mapped = 0;
                title = prmLength === 1 ? this.$t("blockchainBuilder.req") : `${prmLength} ${this.$t("blockchainBuilder.reqParams")}`;
                if (this.scriptRequest.active) {
                    title += (this.$t("blockchainBuilder.script"));
                } else {
                    Object.values(this.requestMapping).forEach(entry => {
                        if (entry) { mapped++; }
                    });
                    if (mapped === 0) {
                        title += `(${this.$t("blockchainBuilder.noMap")})`;
                    } else if (mapped === prmLength) {
                        title += `(${this.$t("blockchainBuilder.allMap")})`;
                    } else {
                        title += ` (${mapped} ${mapped === 1 ? this.$t("blockchainBuilder.param")
                            : this.$t("blockchainBuilder.params")} ${this.$t("blockchainBuilder.mapped")})`;
                    }
                }
            } else {
                title = this.$t("blockchainBuilder.noMethod");
            }
            return title;
        },
        responseTitle() {
            let title;
            if (this.selectionDone) {
                const prmLength = this.responseList.length; let
                    mapped = 0;
                title = prmLength === 1 ? this.$t("blockchainBuilder.resp") : `${prmLength} ${this.$t("blockchainBuilder.resParams")}`;

                if (this.scriptResponse.active) {
                    title += (this.$t("blockchainBuilder.script"));
                } else {
                    Object.values(this.responseMapping).forEach(entry => {
                        if (entry) { mapped++; }
                    });
                    if (mapped === 0) {
                        title += `(${this.$t("blockchainBuilder.noMap")})`;
                    } else if (mapped === prmLength) {
                        title += `(${this.$t("blockchainBuilder.allMap")})`;
                    } else {
                        title += ` (${mapped} ${mapped === 1 ? this.$t("blockchainBuilder.param")
                            : this.$t("blockchainBuilder.params")} ${this.$t("blockchainBuilder.mapped")}  `;
                    }
                }
            } else {
                title = this.$t("blockchainBuilder.noMethod");
            }
            return title;
        },
        requestList() {
            let requestList = [];
            if (this.selectedMethod && this.dataAbi && this.dataAbi.inputs) {
                if (this.dataAbi.inputs) {
                    this.dataAbi.inputs.forEach(elem => {
                        if (!elem.fields) {
                            requestList.push(elem);
                        } else {
                            requestList = requestList.concat(this.parseValues(elem.fields));
                            this.dataReturn = [];
                        }
                    });
                }
            }
            return requestList;
        },
        responseList() {
            let responseList = [];

            if (this.selectedMethod && this.dataAbi && this.dataAbi.outputs) {
                if (this.dataAbi.outputs) {
                    this.dataAbi.outputs.forEach(elem => {
                        if (!elem.fields) {
                            responseList.push(elem);
                        } else {
                            responseList = responseList.concat(this.parseValues(elem.fields));
                            this.dataReturn = [];
                        }
                    });
                }
            }
            return responseList;
        }
    },
    watch: {
        mapping: {
            handler(val) {
                if (Object.keys(val).length !== 0) {
                    this.updateLocalMapping(val || {});
                    this.contractExist = !!val;
                }
            },
            immediate: true
        },
        selectedMethod(selectedMethod) {
            if (selectedMethod) {
                this.dataAbi = this.methodsData.find(elem => elem.name === selectedMethod);
                this.methodType = this.dataAbi.type;
                this.updateLocals(this.dataAbi);
            } else {
                this.clearRequestResponse();
            }
        }
    },
    beforeMount() {
        this.mappingList = this.getMappingList();
        this.requestMappingList = this.mappingList;
        this.responseMappingList = this.mappingList;
    },
    methods: {
        parseValues(data) {
            data.forEach(elem => {
                if (elem.fields) {
                    this.parseValues(elem.fields);
                } else {
                    this.dataReturn.push(
                        {
                            arrayLength: elem.arrayLength,
                            isList: elem.isList,
                            name: elem.name,
                            path: elem.path,
                            type: elem.type
                        }
                    );
                }
            });
            return this.dataReturn;
        },
        sendAbiData(data) {
            this.methodsData = data && data.data ? data.data : null;
            this.fileName = data ? data.fileName : null;
            this.abiToSend = data && data.abiData ? data.abiData : null;
            this.methods = data && data.data ? data.data.map(elem => ({ label: elem.name, value: elem.name })) : null;
            this.selectedMethod = null;
            this.contractExist = !!data;
        },
        filterFnRequest(value, update) {
            update(() => {
                this.requestMappingList = this.filterFn(value);
            });
        },
        filterFnResponse(value, update) {
            update(() => {
                this.responseMappingList = this.filterFn(value);
            });
        },
        filterFn(value) {
            let filteredList;
            if (value === "") {
                filteredList = this.mappingList;
            } else {
                const needle = value.toLowerCase();
                filteredList = this.mappingList.filter(({ label }) => label.toLowerCase().indexOf(needle) > -1);
            }
            return filteredList;
        },
        requestScript(ev, scriptType) {
            const scriptObject = scriptType === "Request" ? this.scriptRequest : this.scriptResponse;

            if (scriptObject.active) {
                this.currentEdit = scriptType;
                this.localValue = scriptObject.content;
                this.showModal = true;
            }

            ev.stopImmediatePropagation();
        },
        onUpdate(value) {
            if (this.currentEdit === "Request") {
                this.scriptRequest.content = value;
            } else {
                this.scriptResponse.content = value;
            }
            this.currentEdit = null;
        },
        getMappingObject(deleteMapping) {
            let mappingObject = {};
            if (!deleteMapping) {
                if (this.selectedMethod && this.methodType === null) {
                    this.dataAbi = this.methodsData.find(({ name }) => name === this.selectedMethod);
                    this.methodType = this.dataAbi.type;
                }

                mappingObject = {
                    network: this.bcAddress,
                    chainId: this.chainId,
                    method: this.selectedMethod,
                    methodType: this.methodType,
                    dataFromContract: this.methodsData,
                    contract: {
                        address: this.address,
                        abi: this.abiToSend
                    }
                };
                mappingObject._request = { ...this.scriptRequest };
                mappingObject._response = { ...this.scriptResponse };

                mappingObject.request = { ...this.requestMapping };
                mappingObject.response = { ...this.responseMapping };
                mappingObject.fileName = this.fileName;
            }

            return mappingObject;
        },
        modalAction(action) {
            if (action.simple === "hide") {
                this.localShow = ["action_backdrop", "action_esc"].includes(action.detailed);
            } else if (action.simple === "action") {
                if (action.detailed === "save") {
                    if (this.address && this.bcAddress) {
                        this.$emit("update", this.getMappingObject());
                        this.localShow = false;
                        this.noAddress = false;
                        this.noBcAddress = false;
                        this.$toast.showNotify({
                            message: this.$t("blockchainBuilder.succes"),
                            type: "positive"
                        });
                    } else {
                        this.noAddress = !this.address;
                        this.noBcAddress = !this.bcAddress;
                    }
                }
                if (action.detailed === "delete") {
                    this.$emit("update", this.getMappingObject("delete"));
                    this.localShow = false;
                    this.$toast.showNotify({
                        message: this.$t("blockchainBuilder.deleteSucces"),
                        type: "positive"
                    });
                }
            }
        },
        clearRequestResponse() {
            this.requestMapping = {};
            this.responseMapping = {};
        },
        updateLocals(method) {
            const request = method.inputs;
            const response = method.outputs;
            this.clearRequestResponse();
            request.forEach(entry => {
                this.$set(this.requestMapping, entry.path, null);
                if (entry.fields) {
                    this.parseFields(entry.fields, "request");
                }
            });
            response.forEach(entry => {
                this.$set(this.responseMapping, entry.path, null);
                if (entry.fields) {
                    this.parseFields(entry.fields, "response");
                }
            });
        },
        parseFields(array, action) {
            array.forEach(field => {
                const mapping = action === "request" ? this.requestMapping : this.responseMapping;
                this.$set(mapping, field.path, null);
                if (field.fields) {
                    this.parseFields(field.fields, action);
                }
            });
        },
        updateLocalMapping(val) {
            val = this.__updateToLatestFormat(val);
            this.methodsData = val.dataFromContract;
            this.fileName = val.fileName;
            this.methods = this.methodsData.map(elem => ({ label: elem.name, value: elem.name }));

            if (val.hasOwnProperty("_request")) { this.scriptRequest = { ...val._request }; }
            if (val.hasOwnProperty("_response")) { this.scriptResponse = { ...val._response }; }
            this.chainId = val.chainId ? val.chainId : null;
            this.bcAddress = val.network ? val.network : null;
            this.address = val.contract && val.contract.address ? val.contract.address : null;
            this.selectedMethod = val.method;
            this.abiToSend = val.contract && val.contract.abi ? val.contract.abi : null;

            if (this.selectedMethod) {
                this.dataAbi = this.methodsData.find(elem => elem.name === this.selectedMethod);
                this.updateLocals(this.dataAbi);

                this.requestMapping = val.hasOwnProperty("request") ? { ...val.request } : {};
                this.responseMapping = val.hasOwnProperty("response") ? { ...val.response } : {};
            } else {
                this.requestMapping = {};
                this.responseMapping = {};
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        getMappingList() {
            const mappingList = [];

            Object.entries(this.properties).forEach(([key, data]) => {
                const configProps = this.components[data.__component];
                const isInNamespace = guid => {
                    let done = false; let { parent } = this.properties[guid]; let currentProps;
                    while (parent && !done) {
                        currentProps = this.properties[parent];
                        if (this.components[currentProps.__component].namespace) {
                            done = true;
                        } else {
                            parent = currentProps.parent;
                        }
                    }
                    return done;
                };

                if (configProps.get || configProps.set) {
                    const labelValue = data.label || data.checkLabel || data.toggleLabel || data.code || key;
                    if (isInNamespace((key))) {
                        mappingList.push({
                            label: `[ ].${labelValue}`,
                            value: key,
                            icon: configProps.icon
                        });
                    } else {
                        mappingList.push({
                            label: labelValue,
                            value: key,
                            icon: configProps.icon
                        });
                    }
                }
            });
            return mappingList;
        }
    }
};
